import React from 'react';
import './ChoicePicker.css';

export type ChoicePickerOption<T extends string> = {
  value: T;
  label: string;
};

export interface ChoicePickerProps<T extends string> {
  value: T | null;
  options: ReadonlyArray<ChoicePickerOption<T>>;
  onChange: (next: T) => void;
  className?: string;
}

const ChoicePicker = <T extends string>({ value, options, onChange, className }: ChoicePickerProps<T>) => {
  return (
    <div className={`ff-choice-picker ${className ?? ''}`.trim()}>
      {options.map((opt) => {
        const selected = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            className={`ff-choice-picker__btn ${selected ? 'ff-choice-picker__btn--selected' : ''}`}
            onClick={() => onChange(opt.value)}
          >
            <span className="ff-choice-picker__dot" aria-hidden />
            <span className="ff-choice-picker__label">{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ChoicePicker;

